// @flow

// removeNullAndUndefinedProps will recursively walk the object, removing
// properties with a value of null, undefined, "Invalid Date" or empty string.
//
// Helpful when validating Objects against schemas as Java Json validation
// ignores null or undefined values by default
export const removeNullAndUndefinedProps = (obj: Object): Object => {
  return obj
    ? Object.keys(obj).reduce((acc, k) => {
        const isEmptyString = typeof obj[k] === "string" && obj[k].trim() === "";
        if (
          obj[k] !== null &&
          obj[k] !== undefined &&
          !isEmptyString &&
          obj[k] !== "Invalid Date"
        ) {
          if (typeof obj[k] === "object" && !Array.isArray(obj[k])) {
            return { ...acc, [k]: removeNullAndUndefinedProps(obj[k]) };
          }

          if (Array.isArray(obj[k])) {
            return {
              ...acc,
              [k]: obj[k].map(d => {
                if (d && typeof d === "object") {
                  return removeNullAndUndefinedProps(d);
                }

                return d;
              }),
            };
          }

          return { ...acc, [k]: obj[k] };
        }

        return acc;
      }, {})
    : {};
};

// Filtering out all array with null or empty object values
// Examples like :
// removeEmptyArraysAndObjects( {} )
// ageGroups: (2) ["TWENTY_OR_UNDER", undefined] >>>  ageGroups: ["TWENTY_OR_UNDER"]
// alertTypes: Array(2) [{id: 4}, {}] >>> [{id: 4}]
export const removeEmptyGroupsFromObjectProperties = (objectToFilter: Object) => {
  for (let k in objectToFilter) {
    let val = objectToFilter[k];
    if (typeof val === "object" && Array.isArray(val)) {
      // if its array     (staffGroups)
      const filtered = val.filter(filteredVal => {
        let criteria;
        if (typeof filteredVal === "object") criteria = filteredVal.id;
        else criteria = filteredVal;
        return criteria !== undefined;
      });
      if (filtered.length < 1) delete objectToFilter[k];
      else objectToFilter[k] = filtered;
    } else if (typeof val === "object") {
      // if its object    (columns)
      if (val !== null && Object.entries(val).length < 1) {
        delete objectToFilter[k];
      }
    } else if (val === "") {
      delete objectToFilter[k];
    }
  }
  return objectToFilter;
};
